import gql from 'graphql-tag';

import remoteItemFromProviderFragment from './remoteItemFromProviderFragment';

export const suggestedSyncFolderRemoteItemFragment = gql`
  fragment suggestedSyncFolderRemoteItemFragment on SuggestedSyncFolderRemoteItem {
    dokkioClass
    count
    paths
    remoteItem {
      ...remoteItemFromProviderFragment
    }
  }
  ${remoteItemFromProviderFragment}
`;
export default suggestedSyncFolderRemoteItemFragment;
